import SubcategoryPage from '@/components/template/SubcategoryPage';

const MuvetPanca = () => {
  const products = [
    {
      title: "Muvet Panca Standard",
      imageSrc: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&q=80",
      url: "/proizvodi/muvet-panca-standard"
    },
    {
      title: "Muvet Panca Premium",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80",
      url: "/proizvodi/muvet-panca-premium"
    },
    {
      title: "Muvet Panca Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/muvet-panca-deluxe"
    },
    {
      title: "Muvet Panca Compact",
      imageSrc: "https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/muvet-panca-compact"
    },
    {
      title: "Muvet Panca Comfort",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/muvet-panca-comfort"
    },
    {
      title: "Muvet Panca Elegance",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/muvet-panca-elegance"
    }
  ];

  return (
    <SubcategoryPage
      title="Muvet Panca"
      description="Elegantna serija klopi Muvet Panca združuje funkcionalnost in estetiko za popolno dopolnitev vašega prostora."
      heroImage="https://images.unsplash.com/photo-1618220179428-22790b461013?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default MuvetPanca;